import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatDate, postPath } from "../../lib/blog";

export const PostCard = ({ post }) => (
    <Link
        to={postPath(post.slug)}
        data-testid={`blog-card-${post.slug}`}
        className="group flex flex-col overflow-hidden rounded-2xl border border-brand-brown/10 bg-white transition-shadow duration-200 hover:shadow-lg"
    >
        <div className="aspect-[4/3] overflow-hidden bg-brand-cream">
            <img
                src={post.cover}
                alt={post.coverAlt}
                width="1024"
                height="765"
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
            />
        </div>
        <div className="flex flex-1 flex-col p-5 sm:p-6">
            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-orange">
                {post.category} · {post.readMinutes} min read
            </p>
            <h3 className="mt-3 font-display text-xl font-bold leading-snug tracking-tight text-brand-brown group-hover:text-brand-orange-dark">
                {post.title}
            </h3>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-brand-muted">{post.description}</p>
            <p className="mt-5 flex items-center justify-between text-sm font-semibold text-brand-brown">
                <span className="font-mono text-xs font-normal text-brand-muted">{formatDate(post.date)}</span>
                <span className="inline-flex items-center gap-1 text-brand-orange">
                    Read article <ArrowUpRight size={15} aria-hidden="true" />
                </span>
            </p>
        </div>
    </Link>
);
